export default {
  mobilePlanAssistance: {
    id: 'checkout_services_reassurance_items_mobile_plan_assistance',
    defaultMessage: '{partnerLabel} assistance',
  },
}
